import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const thumbProps = buildProps({
  vertical: Boolean,
  size: String,
  move: Number,
  ratio: {
    type: Number,
    required: true
  },
  always: Boolean
});

export { thumbProps };
//# sourceMappingURL=thumb.mjs.map
